import { border, space } from 'styled-system';
import { PropTypes } from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { Box } from '../../grid';
import { colors } from '../../../constants';
import { Icon } from '../../icons';
import { P } from '../../typography/new';

const AutocompleteSuggestion = ({
  description,
  formattedAddress,
  showLocationIcon,
  showRightIcon,
  showDetailedListView,
  ...suggestionItemProps
}) => {
  if (showDetailedListView) {
    return (
      <Suggestion
        borderBottomStyle="solid"
        borderBottomWidth="1px"
        borderColor="warmWhite3"
        showLocationIcon={showLocationIcon}
        py="16px"
        {...suggestionItemProps}
      >
        <Box mr="8px" textAlign="center">
          <Icon name="locationMarker" width="40px" fill="black" />
        </Box>
        <Box data-testid="autoCompleteSuggestion--description">
          <P color="black" data-testid="autoCompleteSuggestion--formatted" variant="standard-semi-bold">
            {formattedAddress.mainText}
          </P>
          <P variant="extra-small" pt="4px" color="black">
            {formattedAddress.secondaryText}
          </P>
        </Box>
      </Suggestion>
    );
  }

  return (
    <Suggestion showLocationIcon={showLocationIcon} type="button" padding="16px 0" {...suggestionItemProps}>
      {showLocationIcon && <Icon name="locationMarker" mr="8px" width="24px" fill="black" />}
      <SuggestionText variant="small" data-testid="autoCompleteSuggestion--description">
        {formattedAddress ? (
          <>
            <SuggestedTextBold data-testid="autoCompleteSuggestion--formatted">
              {formattedAddress.mainText}
            </SuggestedTextBold>{' '}
            {formattedAddress.secondaryText}
          </>
        ) : (
          <>{description}</>
        )}
      </SuggestionText>
    </Suggestion>
  );
};

const Suggestion = styled.button`
  ${border}
  ${space}
  display: flex;
  align-items: center;
  text-align: left;
  color: ${colors.grey50};
  width: 100%;

  :hover {
    background-color: ${colors.warmWhite02};
  }
`;

const SuggestionText = styled(P)`
  flex: 1;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  position: relative;
`;

const SuggestedTextBold = styled.span`
  color: ${colors.black};
`;

AutocompleteSuggestion.propTypes = {
  description: PropTypes.string.isRequired,
  formattedAddress: PropTypes.shape({
    mainText: PropTypes.string.isRequired,
    secondaryText: PropTypes.string,
  }),
  showDetailedListView: PropTypes.bool,
  showLocationIcon: PropTypes.bool,
  showRightIcon: PropTypes.bool,
};

AutocompleteSuggestion.defaultProps = {
  formattedAddress: null,
  showDetailedListView: false,
  showLocationIcon: false,
  showRightIcon: false,
};

export { AutocompleteSuggestion };
